import { Button, Col, Form, Input, Row, Select, Typography } from "antd";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { getAddCollection } from "../../api/Get";
import { useForm } from "antd/es/form/Form";
import { postAddCollection } from "../../api/Post";

const { Title, Text } = Typography;

const addCollectionLoader = async () => {
  const details = await getAddCollection();
  return details;
};

const AddCollection = () => {
  const navigate = useNavigate();
  const { pubHouse } = useLoaderData();
  const { state } = useLocation();

  const [form] = useForm();

  const [errorMsg, setErrorMsg] = useState("");

  const onFinish = async (values) => {
    const res = await postAddCollection(values);
    console.log(res);
    if (res.error) setErrorMsg(res.error);
    else
      navigate("/serie/add", {
        state: { collectionName: res.collection.name },
      });
  };

  return (
    <>
      <Title level={2}>Ajouter une collection</Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          collectionState: "admin",
          pubHouseName: state?.pubHouseName,
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Maison d'édition"
              name="pubHouseName"
              rules={[
                { required: true, message: "Choisir une maison d'édition" },
              ]}
            >
              <Select
                showSearch
                placeholder="Rechercher une maison d'édition"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                options={pubHouse.map((c) => {
                  return { label: c.name, value: c.name };
                })}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Statut de la collection" name="collectionState">
              <Select
                options={[
                  { value: "free", label: "Gratuit" },
                  { value: "admin", label: "Administrateur" },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Nom de la collection"
              name="collectionName"
              rules={[
                { required: true, message: "Choisir un nom de collection" },
              ]}
            >
              <Input placeholder="Lulu à Brest" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="UID Collection"
              name="uidCollection"
              rules={[{ required: true, message: "Insérer un UID valide" }]}
            >
              <Input placeholder="UID_COLLECTION" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item wrapperCol={{ span: 16 }}>
          <Button type="primary" htmlType="submit">
            Enregistrer
          </Button>
        </Form.Item>
        <Text type="danger">{errorMsg}</Text>
      </Form>
    </>
  );
};

export { AddCollection, addCollectionLoader };
